export default "__VITE_ASSET__wMHky8YF__"